import '@hapana/shared/utils/type-defs.util'

/** @type{Styles} */
export const styles = {
  checkinWrapper: {
    border: {
      xs: 0,
      sm: 1,
    },
    borderRadius: 1,
    color: 'gray.8',
    paddingTop: 0,
  },
}
